import QRCode from "react-qr-code";
import ZaffloLogo from "../../assets/fav.png";

export default function QRGenerator({ pdfUrl, settings }) {
  if (!pdfUrl) return null;

  return (
    <div className="flex justify-center items-center">

      {/* 🎴 PREMIUM CARD */}
      <div className="w-full max-w-[260px] bg-white rounded-2xl px-5 py-6 text-center flex flex-col items-center 
        shadow-[0_0_60px_rgba(255,255,255,0.06)] ring-1 ring-white/10">

        {/* 🖼 BUSINESS LOGO */}
        {settings.logo && (
          <div className="mb-3">
            <div className="w-12 h-12 rounded-lg bg-black/5 flex items-center justify-center">
              <img
                src={settings.logo}
                alt="business logo"
                className="w-9 h-9 object-contain"
              />
            </div>
          </div>
        )}

        {/* 🏷 BUSINESS NAME */}
        {settings.businessName && (
          <h3 className="text-[14px] font-semibold text-black/80 mb-4 leading-tight">
            {settings.businessName}
          </h3>
        )}

        {/* 🔲 QR SECTION */}
        <div className="relative bg-white p-3 rounded-xl border border-black/5">

          <QRCode
            value={pdfUrl}
            size={170}
            bgColor={settings.bgColor || "#ffffff"}
            fgColor={settings.qrColor || "#000000"}
          />

          {/* 🔥 CENTER LOGO */}
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <div className="bg-white p-1.5 rounded-md ring-1 ring-black/5">
              <img
                src={ZaffloLogo}
                alt="Zafflo"
                className="w-6 h-6 object-contain"
              />
            </div>
          </div>

        </div>

        {/* 📄 INSTRUCTION */}
        <p className="text-[13px] text-black/60 mt-4">
          Scan to view menu
        </p>

        {/* 🔥 BRANDING */}
        <p className="text-[10px] text-black/40 mt-2 tracking-wide">
          Powered by Zafflo
        </p>

      </div>
    </div>
  );
}